export const calculateCouponAmount = (amount?: number): string | undefined => {
  if (amount) {
    return (amount / 100).toString();
  }
  return undefined;
};
